import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SendOutlined } from '@ant-design/icons';
import Flex from '../Flex/Flex';
import Text from '../Text/Text';
import FAQIcon from '../../assets/Icons/FAQIcon.svg?react';
import TopPlayersIcon from '../../assets/Icons/TopPlayersIcon.svg?react';
import classNames from 'classnames';
import './PublicHeader.css';

const MANAGER_TELEGRAM_URL = 'https://t.me/fishh_support';

const PublicHeader = React.memo(() => {
  const { t } = useTranslation('translation');
  const { pathname } = useLocation();
  const isFaqActive = pathname.toLowerCase() === '/faq';
  const isTopPlayersActive = pathname.toLowerCase() === '/top-players';

  return (
    <header className="PublicHeader">
      <Flex className="PublicHeader__Content" align="center" justify="space-between">
        <Link className="PublicHeader__Logo" to="/" aria-label="Fish Hunter" />

        <Flex className="PublicHeader__Nav" align="center" gap={0}>
          <Link
            className={classNames('PublicHeader__Link', {
              'PublicHeader__Link--active': isTopPlayersActive,
            })}
            to="/top-players"
          >
            <i className="PublicHeader__LinkIcon">
              <TopPlayersIcon />
            </i>
            <Text size={3}>{t('top_players')}</Text>
          </Link>

          <Link
            className={classNames('PublicHeader__Link', {
              'PublicHeader__Link--active': isFaqActive,
            })}
            to="/faq"
          >
            <i className="PublicHeader__LinkIcon">
              <FAQIcon />
            </i>
            <Text size={3}>FAQ</Text>
          </Link>

          <a
            className="PublicHeader__Link PublicHeader__Link--telegram"
            href={MANAGER_TELEGRAM_URL}
            target="_blank"
            rel="noreferrer"
          >
            <i className="PublicHeader__LinkIcon PublicHeader__LinkIcon--telegram">
              <SendOutlined />
            </i>
            <Text size={3}>{t('public_header_manager')}</Text>
          </a>
        </Flex>
      </Flex>
    </header>
  );
});

export default PublicHeader;
